import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [pageIsReady, setPageIsReady] = useState(false);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy
        }}>
            {props.children}
        </Provider>
    );
}